import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { Equipment } from '../../../core/interfaces';
import { EquipmentsApi } from '../services/api/equipments.api';
import { DialogEquipmentComponent } from './dialog-equipments.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
import * as i2 from "../services/api/equipments.api";
import * as i3 from "../../../../@fuse/components/progress-bar/progress-bar.service";
import * as i4 from "../../../core/authentication/authentication.service";
var DialogEquipmentService = /** @class */ (function () {
    function DialogEquipmentService(matDialog, equipmentsApi, fuseProgressBarService, authenticationService) {
        this.matDialog = matDialog;
        this.equipmentsApi = equipmentsApi;
        this.fuseProgressBarService = fuseProgressBarService;
        this.authenticationService = authenticationService;
    }
    DialogEquipmentService.prototype.open = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var location, equipmentId, selectedTab, disableEditLocation, equipment;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        location = params.location, equipmentId = params.equipmentId, selectedTab = params.selectedTab, disableEditLocation = params.disableEditLocation;
                        return [4 /*yield*/, this.getEquipment({ equipmentId: equipmentId, location: location })];
                    case 1:
                        equipment = _a.sent();
                        return [2 /*return*/, this.matDialog.open(DialogEquipmentComponent, {
                                panelClass: ['dialog-equipment'],
                                autoFocus: false,
                                data: {
                                    equipment: equipment,
                                    selectedTab: selectedTab,
                                    disableEditLocation: disableEditLocation,
                                }
                            }).afterClosed()
                                .toPromise()];
                }
            });
        });
    };
    DialogEquipmentService.prototype.getEquipment = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var equipmentId, location, result;
            return tslib_1.__generator(this, function (_a) {
                this.fuseProgressBarService.show();
                equipmentId = params.equipmentId, location = params.location;
                result = equipmentId ? this.fetchEquipment(equipmentId) : {
                    name: '',
                    archived: false,
                    location: location || null,
                    type: null,
                    customFields: [],
                };
                this.fuseProgressBarService.hide();
                return [2 /*return*/, result];
            });
        });
    };
    DialogEquipmentService.prototype.fetchEquipment = function (equipmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.equipmentsApi.getEquipmentWithWarrantiesById(equipmentId)];
            });
        });
    };
    DialogEquipmentService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DialogEquipmentService_Factory() { return new DialogEquipmentService(i0.ɵɵinject(i1.MatDialog), i0.ɵɵinject(i2.EquipmentsApi), i0.ɵɵinject(i3.FuseProgressBarService), i0.ɵɵinject(i4.AuthenticationService)); }, token: DialogEquipmentService, providedIn: "root" });
    return DialogEquipmentService;
}());
export { DialogEquipmentService };
